import { Types } from "../../@types"
import React, { useEffect } from "react"
import { appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import { SpotlightApiDataItem, useConditional } from "."

const labelClasses = "text-sm pl-1 text-amber-700"
const fieldClasses = "w-full px-2 py-[6px] bg-slate-800 text-white text-sm focus:outline-none border border-solid border-slate-700 bg-transparent"
const buttonClasses = "px-5 py-1 text-white text-sm border border-solid"
const definitionClasses = "text-sm px-3"

export default function SpotlightItem({ closeFn }:{ closeFn:any }){

  const { store }:any = appStore()
  const { removeDropzoneItem }:any = useConditional()

  const [ handleClose, setHandleClose ] = React.useState<any>(null)


  useEffect(() => {
    console.log("hello")
  },[])

  if( !store.metas.conditionalSpotlight ) return <></>
  return (
    <div className={cn("w-full relative")}>
      { store.metas.conditionalSpotlight?.source === 'tag' && (
        <>
          <p>{store.metas.conditionalSpotlight.value.description}</p>
          { store.metas.conditionalSpotlight.value.type === 'single-client' && (
            <p>If the template in which this tag is applied does not belong to the specified client, then the conditional fails.</p>
          )}
        </>
      )}

      { store.metas.conditionalSpotlight?.source === 'automatic' && (
        <div className="w-full flex flex-col">
          <div>
            <p>This is an automatic {store.metas.conditionalSpotlight.value}.</p>
            { store.metas.conditionalSpotlight.value === 'pass' ? (
              <p>Any zone in which this item has been placed automatically passes.</p>
            ):(
              <p>Any zone in which this item has been placed automatically fails.</p>
            )}
          </div>

          <div className="w-full flex justify-end items-center gap-2 mt-4 pr-0">
            <button type="button" className={cn(buttonClasses, "bg-transparent")} onClick={() => removeDropzoneItem(closeFn)}>Remove</button>
          </div>
        </div>
      )}

      { store.metas.conditionalSpotlight?.source === 'api' && (
        <SpotlightApiDataItem closeFn={closeFn} />
      )}

    </div> 
  )
}